import { Box, SeparatorLine } from "@stenajs-webui/core";
import { Notification } from "@stenajs-webui/modal";
import type { FC } from "react";
import { useDispatch } from "react-redux";

import { removeBookingResultNotification } from "../../../services/notifications/notificationsActions";
import type { BookingResultNotification as BookingResultNotificationType } from "../../../services/notifications/notificationsReducer";
import { NotificationContextProvider } from "../context/NotificationContext";
import {
  BookingResultContent,
  getBookingResultHeaderProps,
} from "../toasts/getBookingResultParams";
import { formatToastRelativeTimestamp } from "../utils/formatToastRelativeTimestamp";

export interface BookingResultNotificationProps {
  bookingResultNotification: BookingResultNotificationType;
  onClose: () => void;
}

export const BookingResultNotification: FC<BookingResultNotificationProps> = ({
  bookingResultNotification,
  onClose,
}) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(removeBookingResultNotification(bookingResultNotification.id));
  };

  const { title, icon, iconBackgroundColor } = getBookingResultHeaderProps(
    bookingResultNotification.bookingResult,
  );

  return (
    <NotificationContextProvider
      value={{ trackerCategory: "NotificationCenter", onRequestClose: onClose }}
    >
      <Box>
        <Notification
          icon={icon}
          text={title}
          onClickClose={onClick}
          timestamp={formatToastRelativeTimestamp(
            bookingResultNotification.createdAt,
          )}
          iconBackgroundColor={iconBackgroundColor}
        >
          <BookingResultContent
            result={bookingResultNotification.bookingResult}
          />
        </Notification>
        <SeparatorLine />
      </Box>
    </NotificationContextProvider>
  );
};
